import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import Form from '../../baseComponents/gui/form/Form';
import Input from '../../baseComponents/gui/input/Input';
import WordForm from './WordForm';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { wordModalContent, wordModalPlaceholders } from '../../../constants/copyright';
import { getValidationTexts } from '../../../constants/form';
import { useRequestsHandlerData } from '../../../hooks/useRequestsHandlerData';
import { useFormErrors } from '../../../hooks/useFormErrors';
import { useTranslation } from '../../../translations';

const { titleIsWord, titleIsNumber, form } = wordModalContent;
const { word, number } = wordModalPlaceholders;

const WordModal = React.forwardRef(function WordModal(props, ref) {
  const { isWord = true, callback } = props;
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const [errors, addNewError] = useFormErrors();

  const close = () => {
    closeModal({ type: 'all' });
  };

  const onSubmit = ({ friendId: word }) => {
    callback(word);
  };

  useRequestsHandlerData([
    {
      address: 'requestsGameCompleteQuest',
      fulfilled: close,
      rejected: () => addNewError({ friendId: { message: getValidationTexts(t).REFERRAL_MESSAGE } }),
    },
  ]);

  return (
    <CustomModal>
      <div className={'word-modal'} ref={ref}>
        <div className={'word-modal__bg'} onClick={close} />
        <div className={'word-modal__content'}>
          <h2 className={'word-modal__title'}>{t(isWord ? titleIsWord : titleIsNumber)}</h2>
          <div className={'word-modal__block'}>
            <Form
              errors={errors}
              onSubmit={onSubmit}
              className={'word-modal__form'}
              as={WordForm}
              slots={{ inputs: getInputs() || [] }}
              data={props}
            />
            <CustomButton
              className={
                'custom-button custom-button_gray word-modal__button word-modal__button_close word-modal_close'
              }
              text={'wordModalContent.cancel'}
              onClick={close}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );

  function getInputs() {
    const inputs = (form(t)?.filter((item) => item.input) ?? []).map((form) => ({
      ...form,
      ...(form?.input ? { input: { ...form?.input, placeholder: isWord ? t(word) : t(number) } } : {}),
    }));

    return inputs.map(({ input }, inputIndex) => {
      const Component = Input;
      return (
        <Component
          key={'FormInput-' + inputIndex}
          {...input}
          rules={input.rules}
          Wrapper={(Input, props, keyStr) => (
            <div className={'word-modal__item-form'} key={keyStr}>
              {Input}
            </div>
          )}
        />
      );
    });
  }
});
export default WordModal;
WordModal.propTypes = {};
